var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOtpIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.022,
    height: 32.295,
    viewBox: "0 0 27.022 32.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_OTP_Secure_1562275",
    "data-name": "noun_OTP Secure_1562275",
    transform: "translate(-113.337 -106.184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1388",
    "data-name": "Group 1388",
    transform: "translate(113.337 106.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5846",
    "data-name": "Path 5846",
    d: "M140.324,114.353c-.02-.893-.033-1.733-.033-2.56a.824.824,0,0,0-.824-.823c-5.024,0-8.852-1.446-12.045-4.553a.824.824,0,0,0-1.15,0c-3.2,3.107-7.021,4.553-12.045,4.553a.824.824,0,0,0-.824.823c0,.817,0,1.648-.033,2.55-.158,8.186-.362,19.385,13.2,24.089a.823.823,0,0,0,.54,0C140.684,133.728,140.479,122.53,140.324,114.353Zm-13.478,22.936c-12.621-4.52-12.406-14.865-12.246-23.195,0-.631.024-1.238.031-1.832a18.2,18.2,0,0,0,12.218-4.629,18.174,18.174,0,0,0,12.218,4.629c0,.594.017,1.2.031,1.832C139.253,122.423,139.468,132.77,126.846,137.289Z",
    transform: "translate(-113.337 -106.183)",
    fill: "#10002e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1387",
    "data-name": "Group 1387",
    transform: "translate(3.503 8.711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1386",
    "data-name": "Group 1386"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5847",
    "data-name": "Path 5847",
    d: "M126.428,141.468h-3.219a.367.367,0,0,0-.366.366v.378a.367.367,0,0,0,.366.366h3.219a.367.367,0,0,0,.367-.366v-.378A.368.368,0,0,0,126.428,141.468Z",
    transform: "translate(-122.843 -137.176)",
    fill: "#10002e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5848",
    "data-name": "Path 5848",
    d: "M140.987,141.554h-3.219a.367.367,0,0,0-.366.366v.378a.367.367,0,0,0,.366.366h3.219a.367.367,0,0,0,.367-.366v-.378A.367.367,0,0,0,140.987,141.554Z",
    transform: "translate(-132.037 -137.23)",
    fill: "#10002e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5849",
    "data-name": "Path 5849",
    d: "M155.546,141.554h-3.219a.366.366,0,0,0-.366.366v.378a.367.367,0,0,0,.366.366h3.219a.367.367,0,0,0,.366-.366v-.378A.366.366,0,0,0,155.546,141.554Z",
    transform: "translate(-141.23 -137.23)",
    fill: "#10002e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5850",
    "data-name": "Path 5850",
    d: "M170.019,141.554H166.8a.367.367,0,0,0-.366.366v.378a.367.367,0,0,0,.366.366h3.219a.367.367,0,0,0,.366-.366v-.378A.367.367,0,0,0,170.019,141.554Z",
    transform: "translate(-150.37 -137.23)",
    fill: "#10002e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5851",
    "data-name": "Path 5851",
    d: "M124.1,132.353l.131.2a.245.245,0,0,0,.332.088l.664-.4v.77a.232.232,0,0,0,.24.24h.221a.232.232,0,0,0,.24-.24v-.77l.661.4a.261.261,0,0,0,.144.046.209.209,0,0,0,.2-.141l.121-.181a.238.238,0,0,0,.036-.211.213.213,0,0,0-.133-.131l-.691-.4.692-.4a.283.283,0,0,0,.17-.195.179.179,0,0,0-.047-.151l-.122-.184a.245.245,0,0,0-.332-.088l-.664.4v-.77a.232.232,0,0,0-.24-.24H125.5a.232.232,0,0,0-.24.24V131l-.661-.4a.26.26,0,0,0-.143-.047.209.209,0,0,0-.2.141l-.121.181a.237.237,0,0,0-.035.211.213.213,0,0,0,.133.13l.688.4-.731.406A.248.248,0,0,0,124.1,132.353Z",
    transform: "translate(-123.621 -129.93)",
    fill: "#10002e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5852",
    "data-name": "Path 5852",
    d: "M138.655,131.224l.691.4-.692.4a.273.273,0,0,0-.1.331l.131.2a.249.249,0,0,0,.21.119.266.266,0,0,0,.121-.031l.664-.4v.77a.232.232,0,0,0,.24.24h.221a.232.232,0,0,0,.24-.24v-.77l.661.4a.259.259,0,0,0,.143.046.209.209,0,0,0,.2-.141l.121-.181a.238.238,0,0,0,.036-.211.214.214,0,0,0-.133-.131l-.691-.4.7-.405a.248.248,0,0,0,.091-.326l-.132-.2a.245.245,0,0,0-.332-.088l-.664.4v-.77a.232.232,0,0,0-.24-.24h-.221a.232.232,0,0,0-.24.24V131l-.661-.4a.26.26,0,0,0-.143-.047.209.209,0,0,0-.2.141l-.121.181a.237.237,0,0,0-.035.211A.214.214,0,0,0,138.655,131.224Z",
    transform: "translate(-132.737 -129.93)",
    fill: "#10002e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5853",
    "data-name": "Path 5853",
    d: "M153.3,131.051l.69.4-.7.4a.248.248,0,0,0-.091.327l.131.2a.245.245,0,0,0,.332.088l.664-.4v.77a.232.232,0,0,0,.24.24h.221a.232.232,0,0,0,.24-.24v-.77l.661.4a.26.26,0,0,0,.144.047.21.21,0,0,0,.2-.141l.12-.181a.238.238,0,0,0,.036-.211.214.214,0,0,0-.135-.131l-.65-.338.7-.4a.247.247,0,0,0,.091-.326l-.131-.2a.245.245,0,0,0-.332-.088l-.664.4v-.77l0-.02c-.045-.18-.143-.284-.269-.284h-.221a.232.232,0,0,0-.24.24v.77l-.661-.4a.26.26,0,0,0-.144-.047.21.21,0,0,0-.2.141l-.12.181a.238.238,0,0,0-.036.211A.213.213,0,0,0,153.3,131.051Z",
    transform: "translate(-141.985 -129.821)",
    fill: "#10002e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5854",
    "data-name": "Path 5854",
    d: "M167.807,132.551a.249.249,0,0,0,.21.119.266.266,0,0,0,.121-.031l.664-.4v.77a.232.232,0,0,0,.24.24h.221a.232.232,0,0,0,.24-.24v-.77l.661.4a.259.259,0,0,0,.143.046.209.209,0,0,0,.2-.141l.121-.181a.239.239,0,0,0,.035-.211.215.215,0,0,0-.131-.13l-.634-.4.706-.408a.247.247,0,0,0,.091-.326l-.131-.2a.245.245,0,0,0-.332-.088l-.664.4v-.77a.232.232,0,0,0-.24-.24h-.221a.232.232,0,0,0-.24.24V131l-.661-.4a.26.26,0,0,0-.143-.047.209.209,0,0,0-.2.141l-.121.181a.238.238,0,0,0-.036.211.215.215,0,0,0,.133.13l.69.4-.686.4a.261.261,0,0,0-.2.168.19.19,0,0,0,.039.182Z",
    transform: "translate(-151.129 -129.93)",
    fill: "#10002e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5855",
    "data-name": "Path 5855",
    d: "M147.074,153.76h-.57v-.573a2.467,2.467,0,0,0-4.935,0v.57H141a.443.443,0,0,0-.443.443v4.722a.443.443,0,0,0,.443.443h6.075a.444.444,0,0,0,.443-.44V154.2A.443.443,0,0,0,147.074,153.76Zm-3.037-2.155a1.585,1.585,0,0,1,1.583,1.582v.57h-3.165v-.57A1.584,1.584,0,0,1,144.036,151.6Zm2.6,3.04v3.837h-5.19v-3.837Z",
    transform: "translate(-134.028 -143.018)",
    fill: "#10002e"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpIco);
export default __webpack_public_path__ + "static/media/otp_ico.3804cff9.svg";
export { ForwardRef as ReactComponent };